// Keeps one bad frame from killing the camera slide, without letting a
// broken tracker pretend to work: a few failures in a row trip the gate,
// and the slide falls back to its demo.

/** Counts consecutive failures; `fail()` returns true once `limit` is reached. */
export function createErrorGate(limit) {
  let streak = 0;
  return {
    ok() {
      streak = 0;
    },
    fail() {
      streak += 1;
      return streak >= limit;
    },
  };
}
